import module from 'module';
const templateUrl = require('./holiday-branches.template.html');

module.component('holidayBranches', {
  templateUrl,
  controller: function () {
  }
});
